import { useTranslation } from "react-i18next";

export default function ErrorPage() {
  const { t } = useTranslation();

  return (
    <div id="error-page">
      <h1>{t("routes.oops")}</h1>
      <p>{t("routes.unexpectedError")}</p>
    </div>
  );
}
